import {DateTime} from "luxon";
import {injectable} from "tsyringe";
import {transformer} from "../decorators/transformer.decorator";
import {KeywordDTO} from "../domain/dtos/keyword.dto";
import {Keyword} from "../domain/entities/keyword.entity";
import {AbstractDtoToEntityTransformer} from "./abstract-dto-to-entity.transformer";

@injectable()
@transformer({
    source: `dto`,
    target: Keyword
})
export class DtoToKeywordTransformer extends AbstractDtoToEntityTransformer<KeywordDTO, Keyword> {

    protected toEntity(dto: KeywordDTO): Promise<Keyword> {

        return Promise.resolve(Object.assign(new Keyword(), {
            key: dto.key,
            shortcut: dto.shortcut ?? ``,
            deletedAt: !!dto.deletedAt ? DateTime.fromSQL(dto.deletedAt) : null,
        }));
    }

}